export enum TwicImageTypes {
    Front = 1,
    Back = 2,
}
